const colors = {
  TEXT_COLOR: "text-blue-700",
  BORDER_COLOR: "border-sky-600",
  THEME_COLOR: "bg-sky-600",
  REVENUE: "text-sky-600",
  HOVER_BUTTON: "md:hover:bg-sky-700",
  SUBMIT_BUTTON: "bg-sky-700",
  SUBMIT_BUTTON_HOVER: "md:hover:bg-sky-600",
};

export default colors;
